import { http } from '@/lib/http';
import {
  type GetTermConsentPendingResponse,
  type GetTermConsentPendingResult,
  createHttpClient,
  getTermConsentPending as getTermConsentPendingCommon,
} from '@monorepo/common';

export type { GetTermConsentPendingResponse, GetTermConsentPendingResult };

export const getTermConsentPending = async (): Promise<GetTermConsentPendingResponse> => {
  const httpClient = createHttpClient(http);
  return await getTermConsentPendingCommon(httpClient);
};
